import React from 'react'

const SuccessModal = ({ show, onClose, success, message }) => {
  if (!show) return null;
  return (
    <div 
    className="modal" 
    style={{ 
      display: show ? 'block' : 'none',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 1050
    }}
    onClick={onClose}
  >
    <div 
      className="modal-dialog modal-dialog-centered"
      onClick={e => e.stopPropagation()}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">
            {success ? "Success!" : "Error"}
          </h5>
          <button 
            type="button" 
            className="btn-close" 
            onClick={onClose}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          <button 
            type="button" 
            className="btn btn-primary" 
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
  )
}

export default SuccessModal